import { render, staticRenderFns } from "./BankdraftTabComponent.vue?vue&type=template&id=c1b1699c&scoped=true"
import script from "./BankdraftTabComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./BankdraftTabComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BankdraftTabComponent.vue?vue&type=style&index=0&id=c1b1699c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b1699c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1b1699c')) {
      api.createRecord('c1b1699c', component.options)
    } else {
      api.reload('c1b1699c', component.options)
    }
    module.hot.accept("./BankdraftTabComponent.vue?vue&type=template&id=c1b1699c&scoped=true", function () {
      api.rerender('c1b1699c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/billing/BankdraftTab/BankdraftTabComponent.vue"
export default component.exports